var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.buttonClass,attrs:{"to":_vm.to,"type":"button"}},[_vm._t("default"),(_vm.withArrow)?_c('unicon',{staticClass:"scroller__arrow",attrs:{"name":"arrow-right","width":"40","height":"40"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }